




























































import Vue from 'vue'
import { Table, TableColumn, Button } from 'element-ui'
import './StreamList.scss'
import { Stream } from '@/types/streams'
import { StreamUrl } from '@/classes/streamurl'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { Feature } from '@/featureFlags/featureFlags'

interface StreamTableItem extends Stream {
  lowercaseName: string,
  streamurl: string,
  streamkey: string
}

export default Vue.extend({
  name: 'StreamList',
  props: {
    streams: {
      type: Object as () => Stream
    },
    tab: {
      type: String
    }
  },
  computed: {
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    canEditStream (): boolean {
      if (this.tab === 'broadcast' && this.isSelfServe && !this.canDoOps) {
        return false
      } else {
        return this.$can(AbilityAction.Edit, AbilitySubject.Stream)
      }
    },
    canDeleteStream (): boolean {
      if (this.tab === 'broadcast' && this.isSelfServe && !this.canDoOps) {
        return false
      } else {
        return this.$can(AbilityAction.Delete, AbilitySubject.Stream)
      }
    },
    convertedStreams (): StreamTableItem[] {
      const arr: StreamTableItem[] = []
      Object.entries(this.streams).forEach(([key, stream]) => {
        const el: StreamTableItem = { id: key, ...stream }
        if (el.type !== this.tab || el.deleted === true) return
        if (el.name) {
          el.lowercaseName = el.name.toLowerCase()
          const strurl = new StreamUrl(el.auth_info?.ingest_url ?? el.srcurl)
          if (strurl.valid) {
            el.streamurl = strurl.streamurl || ''
            el.streamkey = strurl.streamkey || ''
          }
          arr.push(el)
        }
      })
      return arr
    }
  },
  methods: {
    edit (streamId: string) {
      this.$emit('editStream', streamId)
    },
    remove (streamId: string) {
      this.$confirm('Are you sure you want to delete this stream?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$emit('deleteStream', streamId)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        //
      })
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-button': Button
  }
})
